(function ($) {
    $(document).ready(function () {
        openSearch();
        blockEmptySeach();
    });

    function openSearch() {
        $(".toggle-search").on("click", function () {
            $(".search-form-container").toggleClass("open");
        });
    }

    function blockEmptySeach() {
        $(".btn-search").on("click", function (e) {
            if ($(this).parent().find(".search-field").val() == "") {
                e.preventDefault();
            }
        });
    }
})(jQuery);
